function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { GALLERY_CONSTS } from 'pro-gallery'; // use base styles

var baseStyles = {
  videoPlay: GALLERY_CONSTS.videoPlay.AUTO,
  cubeType: GALLERY_CONSTS.cubeType.FIT,
  itemClick: GALLERY_CONSTS.itemClick.NOTHING,
  galleryLayout: GALLERY_CONSTS.layout.SLIDESHOW,
  slideshowInfoSize: 0,
  videoSound: true
};
export var fixedStyles = {
  desktopExpand: _objectSpread(_objectSpread({}, baseStyles), {}, {
    slideAnimation: GALLERY_CONSTS.slideAnimations.FADE,
    arrowsPosition: GALLERY_CONSTS.arrowsPosition.OUTSIDE_GALLERY
  }),
  desktopFullscreen: _objectSpread(_objectSpread({}, baseStyles), {}, {
    slideAnimation: GALLERY_CONSTS.slideAnimations.FADE,
    arrowsPosition: GALLERY_CONSTS.arrowsPosition.ON_GALLERY
  }),
  mobileExpand: _objectSpread(_objectSpread({}, baseStyles), {}, {
    slideAnimation: GALLERY_CONSTS.slideAnimations.SCROLL,
    showArrows: false,
    hidePlay: false,
    showVideoPlayButton: true
  }),
  mobileFullscreen: _objectSpread(_objectSpread({}, baseStyles), {}, {
    slideAnimation: GALLERY_CONSTS.slideAnimations.SCROLL,
    showArrows: false
  })
};